/**
 * WHAT: Location Page Initialization Module
 * WHY: Handle location page specific functionality
 * HOW: JavaScript module with proper imports and exports
 * IMPORTANCE: Separates concerns and follows industry standards
 */

// Import location specific functionality
import './location.js';

// Initialize location page
function initializeLocationPage() {
    // Any location page specific initialization can go here
    console.log('Location page initialized');
    
    // Note: Background image is handled by location.js
    // No need for duplicate background image handling here
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeLocationPage);

// Export for potential use in other modules
export { initializeLocationPage };
